
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Tab from './Tab';

const Tabs = (props) => {

    const classNames = mergeStyleSets({
        Tabs: {
            backgroundColor: '#eeeeee',
            height: '100%'
        }
    });

    const onClick = (name) => {
        if (props.onClick) {
            props.onClick(name);
        }
    };

    return (
        <Stack className={classNames.Tabs}>
            {props.children.map(item => {
                return (
                    <Tab
                        key={item.props.name}
                        name={item.props.name}
                        title={item.props.title}
                        iconName={item.props.iconName}
                        active={props.active === item.props.name}
                        onClick={onClick}
                    />
                )
            })}
            <Stack.Item grow>
                <div></div>
            </Stack.Item>
            {props.additionalContent}
        </Stack>
    );
}

export default Tabs;
